import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { formatLocalDateOnly } from "../shared utils/dateFormatters.js";

const CSV_HEADERS = [
  "Campus",
  "First Name",
  "Last Name",
  "Allergies",
  "Type",
  "Arrival Date",
  "Departure Date",
];

function fmtDate(value) {
  if (!value) return "";
  return formatLocalDateOnly(new Date(value)) || "";
}

function flattenRows(groupedByCampus) {
  const rows = [];
  Object.entries(groupedByCampus || {}).forEach(([campus, list]) => {
    (list || []).forEach((row) => rows.push({ campus, ...row }));
  });
  return rows;
}

function slug(value) {
  return String(value || "")
    .trim()
    .replace(/[^a-z0-9]+/gi, "_")
    .replace(/^_+|_+$/g, "")
    .toLowerCase();
}

export function downloadAllergiesCsv(groupedByCampus, selectedYear, scopeLabel) {
  const body = flattenRows(groupedByCampus).map((r) => [
    r.campus,
    r.firstName,
    r.lastName,
    r.allergies,
    r.personType,
    fmtDate(r.startDate),
    fmtDate(r.endDate),
  ]);

  const csvContent = [CSV_HEADERS, ...body]
    .map((row) =>
      row.map((cell) => `"${String(cell ?? "").replace(/"/g, '""')}"`).join(",")
    )
    .join("\n");

  const suffix = scopeLabel ? `_${slug(scopeLabel)}` : "";
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });
  saveAs(blob, `allergies_${selectedYear}${suffix}.csv`);
}

export function exportAllergiesPdf(groupedByCampus, selectedYear, scopeLabel) {
  const doc = new jsPDF();

  doc.setFontSize(16);
  doc.text(
    `Allergy Summary - ${selectedYear}${scopeLabel ? ` - ${scopeLabel}` : ""}`,
    14,
    18
  );

  const entries = Object.entries(groupedByCampus || {});

  if (entries.length === 0) {
    doc.setFontSize(11);
    doc.text("No allergies to report.", 14, 30);
    doc.save(`allergies_${selectedYear}.pdf`);
    return;
  }

  let startY = 26;

  entries.forEach(([campus, list], index) => {
    if (index > 0 && startY > 250) {
      doc.addPage();
      startY = 20;
    }

    doc.setFontSize(13);
    doc.text(campus, 14, startY);

    autoTable(doc, {
      startY: startY + 4,
      head: [["First Name", "Last Name", "Allergies", "Type", "Arrival", "Departure"]],
      body: (list || []).map((r) => [
        r.firstName,
        r.lastName,
        r.allergies,
        r.personType,
        fmtDate(r.startDate),
        fmtDate(r.endDate),
      ]),
      theme: "grid",
      headStyles: { fillColor: [3, 155, 229] },
      styles: { fontSize: 9 },
      columnStyles: { 2: { halign: "left" } },
      margin: { left: 14, right: 14 },
    });

    startY = doc.lastAutoTable.finalY + 12;
  });

  doc.save(`allergies_${selectedYear}${scopeLabel ? `_${slug(scopeLabel)}` : ""}.pdf`);
}
